module.exports = __webpack_public_path__ + "static/3-24370b2f67cd93db5fa4951829f0991f.png";